module.exports = __webpack_public_path__ + "assets/images/entertainment_phase1.e67650add0d4bbdf3d7b13599feae86d.svg";